var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8754 9.17444C16.8754 8.52695 16.8218 8.05445 16.7058 7.56445H9.16113V10.4869H13.5897C13.5004 11.2132 13.0183 12.3069 11.9468 13.0419L11.9318 13.1397L14.3173 14.9508L14.4825 14.967C16.0004 13.5932 16.8754 11.5719 16.8754 9.17444Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16098 16.8752C11.3306 16.8752 13.152 16.1751 14.4824 14.9677L11.9467 13.0426C11.2681 13.5064 10.3574 13.8301 9.16098 13.8301C7.03601 13.8301 5.23246 12.4564 4.58954 10.5576L4.4953 10.5655L2.01486 12.4467L1.98242 12.5351C3.30383 15.1076 6.01811 16.8752 9.16098 16.8752Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59022 10.5576C4.42059 10.0676 4.32241 9.54257 4.32241 9.0001C4.32241 8.45756 4.42059 7.93258 4.5813 7.44259L4.57681 7.33823L2.06527 5.42676L1.9831 5.46506C1.43848 6.53258 1.12598 7.73135 1.12598 9.0001C1.12598 10.2688 1.43848 11.4676 1.9831 12.5351L4.59022 10.5576Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16103 4.16998C10.6699 4.16998 11.6878 4.80873 12.2682 5.34251L14.536 3.1725C13.1432 1.90375 11.3306 1.125 9.16103 1.125C6.01814 1.125 3.30384 2.89249 1.98242 5.46497L4.58063 7.44249C5.23248 5.54375 7.03604 4.16998 9.16103 4.16998Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.404763bc5e57f71a20f8e7dd8367dc6b.svg";
export { ForwardRef as ReactComponent };